<template>
  <div class="header-actions__global-quicksearch-wrapper">
    <a-icon
      v-if="!isGlobalQuicksearchActive"
      :icon="$options.consts.ICON.HEADER_MAGNIFIER"
      :width="$options.consts.HEADER_ICON_SIZE.DESKTOP"
      :height="$options.consts.HEADER_ICON_SIZE.DESKTOP"
      is-button
      original
      class="header-actions__action-item header-actions__search"
      id="header-search-icon"
      aria-label="Search"
      @click="showGlobalSearchInput"
      @focus="showGlobalSearchInput"
    />
    <div v-else>
      <a-wait-for-element-spinner
        :selector="$options.consts.GLOBAL_SEARCH_SELECTOR"
        @input="onChangeLoadStatus"
      />
      <a-global-quicksearch
        v-show="isGlobalQuicksearchLoaded"
        focus-on-mount
        single-column
        :hide-label="isHeaderCollapsed"
        scrollable
        class="header-actions__global-quicksearch"
        @blur="isGlobalQuicksearchActive = false"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import AIcon, { ICON } from 'shared/AIcon'
import { HEADER_ICON_SIZE } from 'enums/header'
import AWaitForElementSpinner from 'shared/AWaitForElementSpinner'

export default {
  name: 'SearchIcon',
  components: {
    AGlobalQuicksearch: () => import('shared/AGlobalQuicksearch'),
    AIcon,
    AWaitForElementSpinner
  },
  consts: {
    ICON,
    HEADER_ICON_SIZE,
    GLOBAL_SEARCH_SELECTOR:
      '.header-actions__global-quicksearch-wrapper .global-quicksearch__wrapper'
  },
  data() {
    return {
      isGlobalQuicksearchActive: false,
      isGlobalQuicksearchLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      isHeaderCollapsed: 'isHeaderCollapsed'
    })
  },
  watch: {
    '$route.path': {
      handler() {
        this.isGlobalQuicksearchActive = false
      }
    }
  },
  methods: {
    showGlobalSearchInput() {
      this.isGlobalQuicksearchActive = true
    },
    onChangeLoadStatus(isLoaded) {
      if (!isLoaded) {
        this.isGlobalQuicksearchActive = false
      } else {
        this.isGlobalQuicksearchLoaded = true
      }
    }
  }
}
</script>
<style scoped lang="scss">
.header-actions__global-quicksearch-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @include header-icon-size;

  .header-actions__global-quicksearch {
    width: 420px;
    position: absolute;
    top: -4px; // globalSearch input is 40px height, but icon is 32px
    right: 0;
    z-index: $z-index-header-search;

    /deep/ .quicksearch-results__wrapper {
      max-height: calc(100vh - #{$mobile-header-height});
    }

    /deep/ .a-scrollable-content__content-wrapper {
      max-height: calc(100vh - #{$mobile-header-height});
    }
  }
}
</style>
